<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة وكيل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/agentview">وكلاء العقارية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة وكيل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center align-content-center pt-5">
          <div class="col-12 col-md-8 mb-4 mt-5">
            <h5 class="text-brown ms-2">
              <i class="bi bi-clipboard-plus pe-2 text-brown"></i>أضافة وكيل
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="agentError" :alertMessage= "message" />
              </div>
              <div v-if="successAgent" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <form action="" @submit.prevent="agentCreate">
                  <div class="row py-2">
                    <div class="col">
                      <label for="">تحميل الصورة</label>
                      <input type="file" class="form-control" @change.prevent="onFileAdd($event.target.files)">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">الاسم</label>
                      <input type="text" class="form-control" v-model="agentName">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">رقم الجوال</label>
                      <input type="text" class="form-control" v-model="phoneNumber">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="isLoading" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { ref } from 'vue';
export default {
  name:'agent',
  data(){
    return {
      agentError: false,
      message: '',
      agentName: "",
      isLoading: false,
      status: true,
      successAgent: false,
      phoneNumber: "",
      image: "",
    }
  },
  methods:{
    resetData(){
      this.agentName = "";
      this.phoneNumber = "";
      this.image = "";
    },
    agentCreate(){
      this.agentError = false;
      this.successAgent = false;
      this.message = "";
      if(this.agentName == ""){
        this.message = 'يجب إدخال الاسم';
        this.agentError = true;
        return false;
      }
      const formData = new FormData();
      formData.append('name',this.agentName);
      formData.append('mobile',this.phoneNumber);
      formData.append('avatar',this.image);
      formData.append('isActive',this.status);
      this.isLoading = true;
      this.$http.post("/api/admin/agents/create",formData).then(res => {
        this.message = 'تم الاضافة بنجاح';
        this.successAgent = true;
        // this.agentName = '';
        // this.phoneNumber = '';
        this.resetData();
        this.isLoading = false;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.agentError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files) {
      this.image = files[0];
    }
  }
}
</script>